import { Stack } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AccountsAnalyticBlock } from "../../components/accounts";
import { ButtonTabs } from "../../components/ui";
import { CustomLoader } from "../../components/ui/CustomLoader";
import { AppRoutes } from "../../types/enums";
import { accountsTabs } from "../../types/genereal";
import { ReactNode, Suspense } from "react";
import { ActionBlock } from "./ActionBlock";
import { useAppSelector } from "../../hooks";
import { useGetCampaignSummaryQuery } from "../../api";

const tabList = [
  {
    label: "All Accounts",
    path: "list",
  },
  {
    label: "Best by Discovery Rate",
    path: "rate",
  },
  {
    label: "Best by Engagement Rate",
    path: "score",
  },
];

export const AccountsWrapper = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { campaign_id, tab } = useParams();
  const { isEditor } = useAppSelector((state) => state.company.userRoles);

  const { data } = useGetCampaignSummaryQuery({
    campaign_id: campaign_id!,
  });

  const handleChange = (tab: string) => {
    const idx = tabList.findIndex(({ label }) => label === tab);
    if (idx === -1) return;

    navigate(
      `${AppRoutes.ACCOUNTS}/${tabList[idx].path}/${campaign_id}${search}`,
    );
  };

  if (!data) {
    return null;
  }

  return (
    <Stack gap={3}>
      {campaign_id && isEditor && (
        <ActionBlock
          campaign_id={campaign_id}
          totalAccounts={data.total_accounts}
          hasContacts={data.has_contacts}
          showTargetAccountPlansBlock={
            data.total_accounts_analyzed > 0 && !data.one_account_plan_complete
          }
          canAnalyzeAll={
            ["allowed", "in_progress"].includes(data.analyze_all_status) &&
            !data.is_ever_analysed
          }
        />
      )}
      <AccountsAnalyticBlock tabs={accountsTabs[tab!]} />
      <ButtonTabs
        currentTab={tabList.find(({ path }) => path === tab)?.label || ""}
        tabList={tabList.map(({ label }) => label)}
        onChange={handleChange}
      />
      <Suspense fallback={<CustomLoader />}>{children}</Suspense>
    </Stack>
  );
};
